export default {
  settings: []
};
